import {
  Button,
  FormControl,
  makeStyles,
  MenuItem,
  Modal,
  Select,
  InputLabel,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allHotelsSelector, selectedBrandSelector } from '../../layouts/property/propertySlice';
import SearchIcon from '@material-ui/icons/Search';
import { duplicateExisitingVendor } from '../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../utils/NotificationUtils';
import './Duplicate-Vendor-Popup.scss';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../utils/loaderSlice';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const DuplicateVendorPopup = (props) => {
  const classes = useStyles();
  const { onDuplicateClose, duplicatePopup, currentHotelId, refreshVendors } = props;
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(duplicatePopup);
  const allHotels = useSelector(allHotelsSelector);
  const selectedBrand = useSelector(selectedBrandSelector);
  const [allHotelForCurrBrand, setAllHotelForCurrBrand] = useState([]);
  const [property, setProperty] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedBrand && allHotels) {
      const filteredHotels = allHotels?.filter((hotel) => hotel?.brandId === selectedBrand);
      setAllHotelForCurrBrand(filteredHotels);
    }
  }, []);

  const handleClose = () => {
    onDuplicateClose();
  };

  const handleOnSubmit = () => {
    if (property !== '' && open && open?.id && currentHotelId) {
      dispatch(stepUpLoaderCount());
      duplicateExisitingVendor(open?.id, currentHotelId, property)
        .then((res) => {
          notificationManager('success', 'Vendor duplicated successfully');
          refreshVendors();
          handleClose();
        })
        .catch((e) => {
          notificationManager('danger', 'Unable to duplicate vendor');
        })
        .finally(() => {
          dispatch(stepDownLoaderCount());
        });
    }
  };

  const getHotelNameFromId = (currId) => {
    return allHotels?.find((hotel) => hotel?.id === currId)?.name;
  };

  const handleVendorType = (type) => {
    switch (type) {
      case 'LIGHTS':
        return 'Lights';
      case 'SCENES':
        return 'Scenes';
      case 'CURTAINS':
        return 'Curtains';
      case 'DIGITAL_DOOR_KEY':
        return 'Digital Door Key';
      case 'THERMOSTAT':
        return 'Thermostats';
      default:
        return '';
    }
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='my-4 duplicate-popup d-flex flex-column'>
        <div className='mb-5'>
          <p className='duplicate-popup-header mb-4 text-center'>Assign to a property</p>
          <FormControl variant='standard' className='w-100 mt-3 mb-5'>
            <InputLabel id='Select_Property_Label'>Select Property</InputLabel>
            <Select
              className='duplicate-popup-select-icon'
              value={property}
              onChange={(e) => {
                setProperty(e.target.value);
              }}
              label='Select Property'
              labelId='Select_Property_Label'
              IconComponent={() => <SearchIcon />}
            >
              {allHotelForCurrBrand &&
                allHotelForCurrBrand?.map((item) => (
                  <MenuItem key={item?.id} value={item?.id}>
                    {item?.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
        {property !== '' && (
          <p className='mx-3 text-center duplicate-popup-info'>
            The selected {duplicatePopup?.name} configurations for{' '}
            {handleVendorType(duplicatePopup?.type)} of {getHotelNameFromId(currentHotelId)} will be
            assigned to {getHotelNameFromId(property)}
          </p>
        )}
        <div className='w-100 d-flex justify-content-center mt-5'>
          <Button
            onClick={(e) => {
              handleClose();
            }}
            variant='outlined'
            type='button'
            className='me-3'
            size='large'
          >
            Cancel
          </Button>
          <Button
            onClick={(e) => {
              handleOnSubmit();
            }}
            variant='contained'
            type='submit'
            color={property !== '' ? 'primary' : 'secondary'}
            disabled={!(property !== '')}
            className='me-3'
            size='large'
          >
            Assign
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <Modal open={open?.duplicate} onClose={handleClose}>
      {body}
    </Modal>
  );
};

export default DuplicateVendorPopup;
